// Angular
import {
  ElementRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

// Service
import { catchError, map, tap } from "rxjs/operators";
import { NgbCarouselConfig } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from '@angular/platform-browser';
import { DepositDataService } from "../../services/deposit-data.service";
import { ImagePreviewDialogComponent } from '../../../../settings/bank-transaction/dialogs/view-transaction-receipt/image-preview/image-preview.component';
@Component({
  selector: "app-deposit-view-receipt",
  templateUrl: "./view-receipt.component.html",
  styleUrls: ["./view-receipt.component.scss"],
  providers: [NgbCarouselConfig],
})
export class ViewReceiptComponent implements OnInit, OnDestroy {
  @ViewChildren("focusfield") focusfield: QueryList<ElementRef>;

  private subscription = new Subscription();

  loading = false;
  remarkLength = 0;
  buttonLoading = false;
  zoomLevel: number[] = [];
  currentSlide = 0;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { deposit: any },
    public dialogRef: MatDialogRef<ViewReceiptComponent>,
    public depositDataService: DepositDataService,
    config: NgbCarouselConfig,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog
  ) {
    config.interval = 0;
    config.keyboard = true;
    config.pauseOnHover = true;
    config.showNavigationIndicators = false;
  }

  ngOnInit() {
    this.data.deposit.receipts = this.data.deposit.receipts.map((receipt: any) => {
      const isPdf = this.checkMedia(receipt.content) === 'pdf';
      return {
        ...receipt,
        content: isPdf ? this.sanitizer.bypassSecurityTrustResourceUrl(receipt.content) : receipt.content,
        isPdf: isPdf,
      };
    });
    this.zoomLevel = this.data.deposit.receipts.map(() => 1);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  adjustZoom(index: number, delta: number): void {
    const newZoom = this.zoomLevel[index] + delta;
    this.zoomLevel[index] = Math.max(0.5, Math.min(newZoom, 3)); 
  }
  checkMedia(url: string) {
    const imageExtensions = [".gif", ".jpg", ".jpeg", ".png"]; // you can add more extensions
    const pdfExtensions = [".pdf"]; // you can add more extensions

    const inc = (ext: string) => url.includes(ext);

    if (imageExtensions.some(inc)) {
      return 'image';
    }

    if (pdfExtensions.some(inc)) {
      return 'pdf';
    }
  }

  onCloseDialog(event?: Event) {
    this.dialogRef.close();
  }
  
  onSlideChange(event: any) {
    const match = event.current?.match(/ngb-slide-(\d+)/);
    if (match) {
      this.currentSlide = parseInt(match[1], 10);
    }
  }

  openImage(image: string) {
    this.dialog.open(ImagePreviewDialogComponent, {
      data: { image },
      panelClass: 'custom-dialog-container'
    });
  }
}
